const LOAD = 'allReviews/LOAD';
const LOAD_SUCCESS = 'allReviews/LOAD_SUCCESS';
const LOAD_FAIL = 'allReviews/LOAD_FAIL';

const LOAD_MORE_REVIEWS = 'allReviews/LOAD_MORE_REVIEWS';
const LOAD_MORE_REVIEWS_SUCCESS = 'allReviews/LOAD_MORE_REVIEWS_SUCCESS';
const LOAD_MORE_REVIEWS_FAIL = 'allReviews/LOAD_MORE_REVIEWS_FAIL';

const initialState = {
  loaded: false,
  loading: false,
  loadingMore: false,
  noMoreToLoad: false,
  reviews: [],
};

export default function recommended(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_MORE_REVIEWS:
      return {
        ...state,
        loadingMore: true
      };
    case LOAD_MORE_REVIEWS_SUCCESS:
      const noMore = action.result && !action.result.length;

      return {
        ...state,
        loadingMore: false,
        reviews: noMore ? state.reviews : state.reviews.concat(action.result),
        noMoreToLoad: noMore,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        reviews: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.allReviews && globalState.allReviews.loaded;
}

export function loadMoreReviews({ index, city = '' }) {
  return {
    types: [LOAD_MORE_REVIEWS, LOAD_MORE_REVIEWS_SUCCESS, LOAD_MORE_REVIEWS_FAIL],
    promise: ({ client }) => client.post('/reviews/loadMore', {
      data: {
        index,
        city,
      }
    })
  };
}

export function loadReviews() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: ({ client }) => client.get('/reviews/all')
  };
}
